export const TIPO_REQUEST = 'TIPO_REQUEST'
export const TIPO_REQUEST_COMBO = 'TIPO_REQUEST_COMBO'
export const TIPO_ERROR = 'TIPO_ERROR'
export const TIPO_CREATE = 'TIPO_CREATE'
export const TIPO_UPDATE = 'TIPO_UPDATE'
export const TIPO_DELETE = 'TIPO_DELETE'




// WEBPACK FOOTER //
// ./src/store/actions/componentType.js